var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Tabbar'),_c('router-view'),_c('div',{staticClass:"returnTop",on:{"click":_vm.returnTop}},[_c('img',{attrs:{"src":require("./assets/top-icon1.png")}})]),_c('footerNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }